import { ThunkAction } from "redux-thunk";
import { RootState } from "slices";
import { Action, Dispatch } from "redux";
import { registerFailed, resetRegister } from "./reducer";
import logger from '../../../utils/logger';

interface User {
    email: string;
    username: string;
    password: string;
}

export const registerUser = (user: User
): ThunkAction<void, RootState, unknown, Action<string>> => async (dispatch: Dispatch) => {
    try {
        // Self-registration is disabled - users are created by administrators
        logger.warn("Self-registration not implemented - users are created by admins");
        dispatch(registerFailed("Self-registration is not available. Please contact your administrator."));
    } catch (error) {
        dispatch(registerFailed(error));
    }
};

export const resetRegisterFlag = () => {
    try {
        const response = resetRegister(false);
        return response;
    } catch (error) {
        return error;
    }
};
